import React from 'react';
import ApprovalMonitorListContainer from '../../containers/approval_monitoring/ApprovalMonitorListContainer';

const ApprovalMonitorListPage = () => {
  return <ApprovalMonitorListContainer />;
};

export default ApprovalMonitorListPage;
